import { LoadablePaint } from '@confluence/loadable';

export type { PageTreeMacroParams } from '../src/PageTreeMacroRenderer.tsx';

export const PageTreeMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeMacro" */ '../src/PageTreeMacroRenderer.tsx'
			)
		).PageTreeMacroRenderer,
});
